import { render } from "./ModalEnviarEmail.vue?vue&type=template&id=2a141dca&scoped=true"
import script from "./ModalEnviarEmail.vue?vue&type=script&lang=js"
export * from "./ModalEnviarEmail.vue?vue&type=script&lang=js"

import "./ModalEnviarEmail.vue?vue&type=style&index=0&id=2a141dca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a141dca"]])

export default __exports__